export default "__VITE_ASSET__af6cd779__"